// extracted by mini-css-extract-plugin
export default {"button-box":"PrimaryButton_button-box__X6mTA","primary":"PrimaryButton_primary__lRJ9d","danger":"PrimaryButton_danger__qXLIt","ghost":"PrimaryButton_ghost__Y5ZKZ"};